import { useOutletContext } from "react-router-dom";
import { Building2, CreditCard, Users } from "lucide-react";

export default function PortalAccount() {
  const { me } = useOutletContext();
  const c = me.org.primary_contact || {};

  const rows = [
    { icon: Building2, label: "Organisation", value: me.org.trade_name ? `${me.org.legal_name} (${me.org.trade_name})` : me.org.legal_name, testid: "account-org-name" },
    { icon: CreditCard, label: "Plan", value: me.org.plan_tier === "pro" ? "Pro" : "Free", testid: "account-plan" },
    { icon: Users, label: "Seats", value: `${me.seats.used} of ${me.seats.limit} in use`, testid: "account-seats" },
  ];

  return (
    <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6" data-testid="portal-account">
      <h1 className="font-display text-2xl font-bold text-forest-deep">Account</h1>
      <p className="mt-1 text-sm text-forest-deep/60">Read only. Changes to plan, seats and passwords are handled by Clymaco staff.</p>

      <div className="mt-6 space-y-3">
        {rows.map(({ icon: Icon, label, value, testid }) => (
          <div key={label} className="flex items-center gap-4 rounded-2xl border border-emerald-950/10 bg-white p-5 shadow-sm">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-600/10 text-emerald-700">
              <Icon className="h-5 w-5" />
            </span>
            <div>
              <div className="font-mono text-[10px] font-semibold uppercase tracking-widest text-forest-deep/50">{label}</div>
              <div className="font-display text-base font-bold text-forest-deep" data-testid={testid}>{value}</div>
            </div>
          </div>
        ))}
        <div className="rounded-2xl border border-emerald-950/10 bg-white p-5 shadow-sm" data-testid="account-contact">
          <div className="font-mono text-[10px] font-semibold uppercase tracking-widest text-forest-deep/50">Primary contact</div>
          <div className="mt-1 text-sm text-forest-deep/80">{c.name} · {c.email}{c.phone ? ` · ${c.phone}` : ""}</div>
        </div>
      </div>
    </main>
  );
}
